/// <amd-module name="typeahead/features/EgtaDemoExperiment" />
/// <amd-dependency path="jquery" name="$"/>

import {Experiment} from "typeahead/core/Experiment";
import {IExperimentalFeature} from "typeahead/core/IExperimentalFeature";
import * as ExecutionHelper from "typeahead/core/plugins/ExecutionHelper";
import * as StripingConfiguration from "typeahead/core/StripingConfiguration";
import {IStripingConfiguration} from "typeahead/core/StripingConfiguration";

const configuration: IStripingConfiguration[] = [
    {
        clients: ["Homepage", "HotelsLandingPage"],
        experiment: {
            id: 32651,
            name: "EGTA_BEX_Shadow_Traffic",
            value: 1,
        },
        lobs: ["HOTELS"],
        locales: ["en_US"],
    },
];

export class EgtaBexShadowTrafficController implements IExperimentalFeature, IRequestUrlParamModifier {

    public getExperiments(): Experiment[] {
        return StripingConfiguration.getExperiments(configuration);
    }

    public modifyParameters(params: ISuggestServiceQueryParams, context: IContext, options?: any):
        ISuggestServiceQueryParams {
        context.egtaBexShadowtraffic = ExecutionHelper.shouldExecute(context, configuration);
        return params;
    }
}
